export default __webpack_public_path__ + "static/cafe_36003-59b39253b68d628d4e93a0d3a734f6ad.png";